import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Constantes } from '../../../shared/constant/constantes';
import { EncuestaSatisfaccion } from '../../../shared/entities/EncuestaSatisfaccion';
import { SerieEstadistica } from '../../../shared/entities/serie-estadistica';
import { VisualizadorService } from '../../../shared/service/visualizador.service';
import { HeaderComponent } from '../../../shared/header/header.component';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatError } from '@angular/material/form-field';


@Component({
    selector: 'app-encuesta-satisfaccion',
    templateUrl: './encuesta-satisfaccion.component.html',
    styleUrls: ['./encuesta-satisfaccion.component.css'],
    standalone: true,
    imports: [CommonModule, HeaderComponent, RouterLink, MatRadioModule, MatError, FormsModule]
})
export class EncuestaSatisfaccionComponent {
  public PREGUNTA_FACILIDAD = 'La facilidad para encontrar la información:';
  public PREGUNTA_ORGANIZACION = 'La presentación, organización y formato en que se encuentra la información:';
  public PREGUNTA_UTILIDAD = 'Utilidad y detalle de la información suministrada:';

  public PREGUNTA_ACTIVIDAD_ECONOMICA = 'En qué sector o actividad económica se desempeña';
  public PREGUNTA_OCUPACION = 'Cuál es su ocupación';
  public PREGUNTA_PROPOSITO = 'Cuál es el principal propósito para la consulta de esta información';
  public PREGUNTA_FRECUENCIA = 'Con qué frecuencia consulta esta información';

  public fechaInicio: Date = new Date();
  public constante: Constantes = new Constantes();
  public informacionSerieSelected: SerieEstadistica = new SerieEstadistica();
  public detalleEncuesta: EncuestaSatisfaccion = new EncuestaSatisfaccion();
  public isAgradecimientos: boolean = false;

  public calificacion: string = '';
  public razonCalificacion: string = '';

  public actividadEconomica: string = '';
  public ocupacion: string = '';
  public proposito: string = '';
  public frecuencia: string = '';

  public facilidad: number = 0;
  public organizacion: number = 0;
  public utilidad: number = 0;

  public idSerie: string = '';
  public productoOrigen: string = '';

  public camposRequeridos = 0;

  constructor(private service: VisualizadorService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.idSerie = this.route.snapshot.paramMap.get('idSerie')!;
    this.productoOrigen = this.route.snapshot.paramMap.get('producto')!;
    this.service.getInformacionBasicaSerie(this.idSerie!).subscribe({
      next: (jsonResponse) => {
        this.informacionSerieSelected = jsonResponse[0];
        if (this.contieneAlgunIdPlan(this.informacionSerieSelected.idPlan, this.constante.LISTA_IDPLAN_ENCUESTA_CERTIFICADA)) {
          this.detalleEncuesta.tipoEncuesta = this.constante.TIPO_ENCUESTA_CERTIFICADA;
        } else {
          this.detalleEncuesta.tipoEncuesta = this.constante.TIPO_ENCUESTA_BASICA;
        }
      },
      error: (error) => {
        console.log("Error inesperado en getInformacionMenu", error);
      }
    });
    this.isAgradecimientos = false;
  }

  enviarCalificacion() {
    var fechaFinal: Date = new Date();
    this.detalleEncuesta.fechaInicial = this.fechaInicio.getTime();
    this.detalleEncuesta.idSerie = this.informacionSerieSelected.id;
    this.detalleEncuesta.nombreTematica = this.informacionSerieSelected.nombre;
    this.detalleEncuesta.productoOrigen = this.productoOrigen;

    if (this.calificacion.length > 0 && this.razonCalificacion.length > 0 && this.facilidad > 0 && this.organizacion > 0 && this.utilidad > 0
      && this.actividadEconomica.length > 0 && this.ocupacion.length > 0 && this.proposito.length > 0 && this.frecuencia.length > 0) {
      //ENCUESTA BASICA
      this.detalleEncuesta.calificacion = this.calificacion;
      this.detalleEncuesta.razonCalificacion = this.razonCalificacion;

      //ENCUESTA CERTIFICADA
      this.detalleEncuesta.accesibilidadDatos = this.PREGUNTA_FACILIDAD + this.facilidad;
      this.detalleEncuesta.ordenDatos = this.PREGUNTA_ORGANIZACION + this.organizacion;
      this.detalleEncuesta.utilidadDatos = this.PREGUNTA_UTILIDAD + this.utilidad;
      this.detalleEncuesta.actividadEconomica = this.PREGUNTA_ACTIVIDAD_ECONOMICA + ':' + this.actividadEconomica;
      this.detalleEncuesta.ocupacion = this.PREGUNTA_OCUPACION + ':' + this.ocupacion;
      this.detalleEncuesta.propositoDatos = this.PREGUNTA_PROPOSITO + ':' + this.proposito;
      this.detalleEncuesta.frecuenciaConsultaDatos = this.PREGUNTA_FRECUENCIA + ':' + this.frecuencia;
      this.detalleEncuesta.fechaFinal = fechaFinal.getTime();
      this.service.generarEncuestaSatisfaccion(this.detalleEncuesta!).subscribe({
        next: (jsonResponse) => {
          console.log('jsonResponse', jsonResponse);
        },
        error: (error) => {
          console.log("Error inesperado en el servicio generarEncuestaSatisfaccion", error);
        }
      });
      this.isAgradecimientos = true;
    } else {
      this.camposRequeridos = 1;
      this.isAgradecimientos = false;
    }
  }

  private contieneAlgunIdPlan(idPlan: string, arregloIdPlanCertif: string[]): boolean {
    return arregloIdPlanCertif.some(id => idPlan.includes(id));
  }
}
